import {RootState} from 'store';

export const getBookExperienceEmail = (state: RootState) => state.bookExperience.email;
